module.exports = {"150430100":"新惠镇","150430101":"四家子镇","150430102":"长胜镇","150430103":"贝子府镇","150430104":"四道湾子镇","150430105":"下洼镇","150430106":"金厂沟梁镇","150430107":"兴隆洼镇","150430108":"黄羊洼镇","150430201":"牛古吐乡","150430202":"木头营子乡","150430203":"古鲁板蒿乡","150430204":"丰收乡","150430205":"玛尼罕乡","150430206":"萨力巴乡","150430207":"敖润苏莫苏木","150430400":"国营种羊场","150430401":"敖汉旗新惠工业园区","150430402":"贝子府化工集中区","150430403":"四家子冶金工业集中区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/150430.json
// module id = 381
// module chunks = 0